import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LiveMealEntity } from '../../domain/entities/LiveMealEntity'
import type { MealListedAdminDto } from '@/backend/market'

export class LiveMealModel extends LiveMealEntity {
  constructor(dataDto: MealListedAdminDto) {
    super()
    mapEntityProperties<LiveMealEntity>(this, dataDto)
  }
}
